export default __webpack_public_path__ + "static/media/Call.86b0cd30.svg";